<template>
    <div class="components-rules-box">
        <div class="box-title">
            <img :src="props.data.icon" alt="" />
            <div class="text">{{props.data.title }}</div> 
        </div>
        <div class="box-list">
            <div class="list-item" v-for="item in props.data.list" :key="item.title">
                <div class="item-title">
                    <img :src="item.icon" alt="" />
                    <div class="text">{{item.title}}</div>
                </div>
                <div class="item-content" v-html="item.desc"></div>
            </div>
        </div>
        <div class="box-btn">
            <div class="btn-box" @click="jumpPath()">
                <img src="https://p3.ssl.qhimg.com/t110b9a930163dda967b4df4f09.png" alt="" />
                立即报名
            </div>
        </div>
    </div>
</template>

<script setup>
const props = defineProps({
  data: {
    type: Object,
    default: () => {
      return {}
    }
  }
})

const jumpPath = () => {
  window.open(props.data.toUrl)
}
</script>

<style lang="scss" scoped>
.components-rules-box{
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-top: 96px;
    .box-title{
        display: flex;
        align-items: center;
        img{
            width: 30px;
            height: 30px;
        }
        .text{
            color: rgb(38, 38, 38);
            font-family: 阿里巴巴普惠体 2.0;
            font-size: 28px;
            font-weight: 700;
            line-height: 39px;
            letter-spacing: 0px;
            margin-left: 12px;
        }
    }
    .box-list{
        display: flex;
        flex-direction: column;
        margin-top: 42px;
        padding-left: 20px;
        .list-item{
            width: 100%;
            display: flex;
            flex-direction: column;
            margin-bottom: 38px;
            .item-title{
                display: flex;
                align-items: center;
                img{
                    width: 10px;
                    height: 10px;
                }
                .text{
                    color: rgb(30, 89, 191);
                    font-family: 阿里巴巴普惠体 2.0;
                    font-size: 20px;
                    font-weight: 700;
                    line-height: 20px;
                    letter-spacing: 0px;
                    margin-left: 14px;
                }
            }
            .item-content{
                margin-left: 24px;
                color: rgb(38, 38, 38);
                font-family: 阿里巴巴普惠体 2.0;
                font-size: 16px;
                font-weight: 300;
                line-height: 32px;
                letter-spacing: 0px;
                margin-top: 12px;
                text-align: justify;
            }
        }
    }
    .box-btn{
        width: 100%;
        display: flex;
        justify-content: center;
        margin-top: 56px;
        .btn-box{
            cursor: pointer;
            width: 159.43px;
            height: 50px;
            border-radius: 8px;
            // background: linear-gradient(180.00deg, rgb(88, 142, 235),rgb(30, 89, 191) 100%);
            background-image: linear-gradient(45deg, rgb(30, 89, 191) 0%, rgb(88, 142, 235)  51%, rgb(30, 89, 191)  100%);
            display: flex;
            align-items: center;
            color: rgb(255, 255, 255);
            font-family: Alibaba PuHuiTi 3.0;
            font-size: 16px;
            font-weight: 500;
            justify-content: center;
            text-transform: uppercase;
            transition: 0.5s;
            background-size: 200% auto;
            border: 0px;
            box-shadow: 0px 0px 14px -7px rgb(88, 142, 235);
            img{
                height: 30px;
                margin-right: 12px;
            }
            &:hover {
                background-position: right center;
                /* change the direction of the change here */
                color: #fff;
                text-decoration: none;
            }
    
            &:active {
                transform: scale(0.95);
            }
        }

    }
}
</style>
